import { useConfirm } from "./ConfirmProvider";
import { useState } from "react";
import { Link } from "react-router-dom";
import toast from "react-hot-toast";
import { relancesAPI } from "../services/api";

const PenaliteControls = ({ facture, onChanged }) => {
  const confirm = useConfirm();
  const calcul = facture.penalites;
  const [busy, setBusy] = useState(false);
  const [multiplier, setMultiplier] = useState(facture.penalites?.multiplicateur_propose ?? 3);
  const [base, setBase] = useState("");
  if (!calcul || facture.statut !== "non_paye") return null;
  const perform = async (operation) => {
    setBusy(true);
    try { await operation(); await onChanged(); toast.success("Conditions de pénalités mises à jour"); }
    catch (error) { const detail = error?.response?.data?.detail;
      toast.error(typeof detail === "string" ? detail : "Vérifiez les conditions saisies"); }
    finally { setBusy(false); }
  };
  const needsConfirmation = ["a_confirmer", "base_manquante"].includes(calcul.etat);
  return <div className="space-y-2">
    {needsConfirmation && !calcul.confirmation_possible && <Link to="/clients" className="text-primary-700 hover:underline">
      Qualifier le client pour les pénalités
    </Link>}
    {needsConfirmation && calcul.confirmation_possible && <details>
      <summary className="cursor-pointer text-primary-700">Confirmer les conditions de cette facture</summary>
      <form className="space-y-2 mt-2" onSubmit={(event) => {
        event.preventDefault();
        perform(() => relancesAPI.confirmPenaltyConditions(facture.id, {
          multiplicateur: Number(multiplier),
          ...(calcul.base_ttc_requise ? { montant_ttc: Number(base) } : {}),
        }));
      }}>
        <label className="block">Multiplicateur du taux légal
          <input className="input-field mt-1" type="number" min="3" step="0.1" required
            value={multiplier} onChange={(event) => setMultiplier(event.target.value)} />
        </label>
        {calcul.base_ttc_requise && <label className="block">Montant TTC ({calcul.devise})
          <input className="input-field mt-1" type="number" min="0" step="0.01" required value={base} onChange={(event) => setBase(event.target.value)} />
        </label>}
        <label className="flex items-start gap-2">
          <input type="checkbox" required className="mt-1" />
          Ces conditions et l'indemnité de 40 EUR figurent sur cette facture et dans les conditions convenues.
        </label>
        <button type="submit" className="text-primary-700 hover:underline disabled:opacity-50" disabled={busy}>Confirmer</button>
      </form>
    </details>}
    {calcul.etat === "taux_manquant" && <Link to="/parametres" className="text-primary-700 hover:underline">Renseigner les taux manquants</Link>}
    {(facture.penalites_conditions?.regime === "france_b2b" || facture.penalites_suspendues) &&
      <button type="button" disabled={busy} className="text-primary-700 hover:underline disabled:opacity-50"
        onClick={async () => {
          if (await confirm({ title: facture.penalites_suspendues ? "Reprendre les pénalités ?" : "Suspendre les pénalités ?", description: "Cette action modifie la prise en compte des pénalités dans le suivi et les rappels de cette facture.", confirmLabel: facture.penalites_suspendues ? "Reprendre les pénalités" : "Suspendre les pénalités", details: [["Facture", facture.numero], ["Client", facture.client_nom]] })) perform(() => relancesAPI.pausePenalties(facture.id, !facture.penalites_suspendues));
        }}>
        {facture.penalites_suspendues ? "Reprendre les pénalités" : "Suspendre les pénalités"}
      </button>}
  </div>;
};

export default PenaliteControls;
